import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd, RouterOutlet, NavigationStart } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { fadeAnimation } from './shared/route-animation';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ScrollToTopComponent } from './shared/scroll-to-top/scroll-to-top.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [fadeAnimation],
  imports: [RouterOutlet, NavbarComponent, FooterComponent, ScrollToTopComponent, SpinnerComponent]
})
export class AppComponent implements OnInit {
  title = 'inloyalty-corporate';
  private urlAnterior: string = '';
  isOverlayVisible = false;
  currentRoute: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private viewportScroller: ViewportScroller
  ) {
    this.currentRoute = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url !== this.currentRoute) {
          this.startTransition();
        }
      } else if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    });
  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlActual = event.urlAfterRedirects;
        if (this.urlAnterior.includes('publicaciones') && (urlActual.includes('publicaciones/category') || urlActual.includes('publicaciones/tag'))) {
          this.viewportScroller.scrollToAnchor('listadoNoticias');
        } else {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
        this.urlAnterior = urlActual;
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      const miDiv = document.getElementById('loading-init');
      if (miDiv) {
        setTimeout(() => {
          miDiv.style.transition = 'opacity 0.5s ease';
          miDiv.style.opacity = '0';
          setTimeout(() => {
            miDiv.style.display = 'none';
          }, 500);
        }, 500);
      }
    }
  }
  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
  startTransition() {
    this.isOverlayVisible = true;
    setTimeout(() => {
      this.isOverlayVisible = false;
    }, 400);
  }
}
